module.exports = __webpack_public_path__ + "img/details-img-03.3f313ec0.png";